export default __webpack_public_path__ + "static/media/bw-working-memory-tutorial-pop-up-icon.a2bd66ce.svg";